// import { ItemTag } from "common/tag/dto/ItemTag";
import { UnitSearchOptions } from "constant/dl_unit/dl_unit.constant";
import { axiosCitajteo } from "../../axios/citajteo_axios";

export type UnitSearchParams = Partial<
  Record<UnitSearchOptions, number | string>
>;

const unitResponseFormat = (unit: any): any => {
  const result = { ...unit };

  return result;
};

export const unitSearch = async (
  searchParams?: UnitSearchParams
): Promise<any> => {
  let result: any = null;
  let response: any;
  try {
    response = await axiosCitajteo.post(`dl-unit/search`, searchParams ?? {});
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
    result.items = result.items.map((item: any) => unitResponseFormat(item));
  }

  return result;
};

// export const topicUpdate = async (
//   id: string,
//   updatePayload: any
// ): Promise<string> => {
//   let result: string = "";
//   let response: any;
//   try {
//     response = await axiosCitajteo.put(`topic/${id}`, updatePayload);
//   } catch (error) {}
//   if (response && response.status === 200) {
//     result = response.data;
//   }

//   return result;
// };

// export const topicDelete = async (id: string): Promise<boolean> => {
//   let result: boolean = false;
//   let response: any;
//   try {
//     response = await axiosCitajteo.delete(`topic/${id}`);
//     result = true;
//   } catch (error) {}
//   if (response && response.status === 200) {
//     result = response.data;
//   }

//   return result;
// };
